export default function Calculations(
  sliderPos: any,
  up: string,
  rake: string,
  bankroll: any,
  betAmount: any,
) {
  const payoutNum = 99 - parseFloat(rake)
  const winchance = up == '0' ? Number(sliderPos) - 1 : 100 - Number(sliderPos)
  const with2Decimals = (payoutNum / winchance)
    .toString()
    .match(/^-?\d+(?:\.\d{0,2})?/)?.[0]
  const payout = with2Decimals
  const profit = betAmount * parseFloat(with2Decimals as string)
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const maxBet = bankroll / parseFloat(with2Decimals as string)
  const res = { maxBet, payout, profit, winchance }
  return res
}
